document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document.querySelectorAll(".menu__item.has-dropdown");
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      item.classList.add("active");
      item.querySelector(".header__dropdown").classList.add("is-visible");
    });
    item.addEventListener("mouseleave", () => {
      item.classList.remove("active");
      item.querySelector(".header__dropdown").classList.remove("is-visible");
    });
  });

  const menuLinks = document.querySelectorAll(".link__item[data-target]");
  const menuProducts = document.querySelectorAll(".header__products-container");
  menuLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      menuLinks.forEach((link) => {
        link.classList.remove("active");
      });
      link.classList.add("active");
      const target = link.dataset.target;
      menuProducts.forEach((product) => {
        if (product.dataset.target === target) {
          product.classList.add("active");
        } else {
          product.classList.remove("active");
        }
      });
    });
  });

  const drawerItems  = document.querySelectorAll("[data-drawer-title]");
  drawerItems.forEach(item => { 
    item.addEventListener('click', () => { 
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        item.nextElementSibling.classList.remove('active');
      }else{
        item.classList.add('active');
        item.nextElementSibling.classList.add('active');
      }
    })
  });

  function ensureMobileNavDrawer() {
    if (!window.jQuery || !window.timber || !window.timber.Drawers) {
      return false;
    }
    if (!window.timber.LeftDrawer || typeof window.timber.LeftDrawer.open !== 'function') {
      window.timber.LeftDrawer = new window.timber.Drawers('NavDrawer', 'left');
    }
    return !!(window.timber.LeftDrawer && typeof window.timber.LeftDrawer.open === 'function');
  }

  function getJqueryClickHandlers(button) {
    if (!button || !window.jQuery) return 0;
    const events = window.jQuery._data(button, 'events');
    return events && events.click ? events.click.length : 0;
  }

  ensureMobileNavDrawer();

  const burgerBtn = document.querySelector('.js-drawer-open-button-left');
  if (burgerBtn) {
    burgerBtn.addEventListener('click', (e) => {
      if (getJqueryClickHandlers(burgerBtn) === 0 && window.timber && window.timber.LeftDrawer) {
        window.timber.LeftDrawer.open(e);
      }
    }, true);
  }
});
